import { Navbar } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import logoutImg from "@/assets/images/logout.svg";
import { useAuth } from "@/context/auth-context";
import { getNavigationItems } from "@/lib/utils";
import { NavigationList } from "./NavigationList";
import { unsubscribeToTransactionEvent } from "@/lib/subscribe-to-notifications";
import { useNotification } from "@/context/notification-context";

export default function NavBar() {
	const { useSignout } = useAuth();

	const [isNavOpened, setIsNavOpened] = useState(false);
	const hideNavigation = () => setIsNavOpened(false);
	const { mutate: signOut } = useSignout();
	const { unSubscribeToChannel } = useNotification();

	const { t } = useTranslation();

	const logout = () => {
		signOut(undefined, {
			onSuccess: () => {},
		});
		unsubscribeToTransactionEvent({ unSubscribeToChannel });
	};
	return (
		<>
			<Navbar
				p={16}
				position={{ top: 0, left: 0 }}
				hiddenBreakpoint="sm"
				hidden={!isNavOpened}
				width={{ sm: 180, lg: 210 }}
				className="bg-secondaryBg border-none"
			>
				<Navbar.Section grow>
					<div className="text-textSecondary text-[14px] leading-[24px] pt-[24px]">
						<NavigationList
							itemSpacing={20}
							links={getNavigationItems(t)}
							hideNavigation={hideNavigation}
						/>
					</div>
				</Navbar.Section>
				<Navbar.Section>
					<div
						className="text-[13px] pt-[24px] flex cursor-pointer text-textSecondary border-b border-b-borderColor pb-3"
						onClick={logout}
					>
						<img src={logoutImg} width={24} alt="logout" />
						<p className="m-0 ml-[10px] text-[14px] text-textSecondary">
							<span>Logout</span>
						</p>
					</div>
					<p className="text-[12px] mb-[24px] mt-[50px] m-0">
					  <span className="text-primaryGold">Powered &nbsp;By &nbsp;</span>	
						<span className="text-[17px] text-[#fffff]">
							E<span className="text-primaryGold">M</span>TECH
						</span>
					</p>
				</Navbar.Section>
			</Navbar>
		</>
	);
}
